import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Options } from 'ng5-slider';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/service/user-service.service';
import { PazientiService } from '../../pazienti/service/pazienti.service';
import { endpoints } from 'src/endpoint/endpoints';
import { CanComponentDeactivate } from 'src/app/unsaved-changes.guard';
import { Observable } from 'rxjs/internal/Observable';

@Component({
  selector: 'app-questionario-valutazione-usabilita',
  templateUrl: './questionario-valutazione-usabilita.component.html',
  styleUrls: ['./questionario-valutazione-usabilita.component.scss']
})
export class QuestionarioValutazioneUsabilitaComponent implements OnInit, CanComponentDeactivate {

  @Input() showAsCard = true;
  @Input() showTitle = true;
  @Input() showFullPage = false;

  idQuestionario;

  domande = new Array();

  options: Options = {
    floor: 1,
    ceil: 5,
    minRange: 1,
    showTicksValues: true,
    tickStep: 1,
    tickValueStep: 1,
    animate: false,
    noSwitching: true
  };

  practitionerRef;
  patientRef;
  clinicalImpressionId;

  @Output() imDirty = new EventEmitter<boolean>();

  lastImDirty = false;


  constructor(private userService: UserService, private toastr: ToastrService, private http: HttpClient, private pazientiService: PazientiService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    // Recupero la reference del medico
    this.practitionerRef = this.userService.getUser().referenceId;
    this.patientRef = "Patient/" + this.pazientiService.getPatientId();
    this.clinicalImpressionId = this.route.snapshot.paramMap.get('vId');

    this.getQuestionario();
  }

  onSliderMouseup(domanda) {
    this.OnChange();
    if (isNaN(domanda.risposta) || domanda.risposta == undefined) {
      domanda.risposta = 1;
    }
  }

  /**
   * Richiede il questionario al server in base al nome passato dal padre
   */
  getQuestionario() {
    this.http.post(endpoints.getQuestionnaireByNameByVersion, { "nome": 'RiAtlasHealthcareUsabilitySUSPazienti', "versione": '1' }).toPromise()
      .then(resp => {
        this.visualizzaQuestionario(resp);
      }).catch(error => {
        this.toastr.error("Impossibile caricare il questionario.");
      });
  }

  /**
   * Crea la struttura del questionario che verrà visualizzato
   * @param questionarioFHIR oggetto FHIR che rappresenta il questionario
   */
  visualizzaQuestionario(questionarioFHIR) {
    this.idQuestionario = questionarioFHIR.id;
    this.domande = questionarioFHIR.item.map(domandaFHIR => ({
      linkId: domandaFHIR.linkId,
      testo: domandaFHIR.text,
      tipo: domandaFHIR.type,
      risposta: undefined,
      risposte: domandaFHIR.option?.map(rispostaFHIR => ({
        testo: rispostaFHIR.valueCoding.display ?? "",
        valore: rispostaFHIR.valueCoding.code,
      })),
      options: {
        floor: 1,
        ceil: 5,
        minRange: 1,
        showTicksValues: true,
        animate: false,
        noSwitching: true,
        stepsArray: this.createStepsArrayFromAnswers(domandaFHIR.option)
      }
    }));
    this.imDirty.emit(false);
    this.lastImDirty = false;
    this.getRisposte();
  }

  /**
   * Crea l'oggetto da mandare al backend ed effettua la chiamata per salvare le risposte.
   */
  salva() {
    if (this.domande.find(x => x.tipo != "string" && (x.risposta == undefined || Number.isNaN(x.risposta))) != undefined) {
      this.toastr.warning("Bisogna rispondere a tutte le domande.");
      return;
    }
    const obj: any = {
      clinicalImpressionId: this.clinicalImpressionId,
      questionnaireId: this.idQuestionario,
      answers: new Array(),
    };
    this.domande.forEach(domanda => {
      obj.answers.push({
        linkId: domanda.linkId,
        type: domanda.tipo,
        value: "" + (domanda.risposta ?? "")
      });
    });
    this.http.post(endpoints.addClinicalImpressionSurveyResponse, obj).toPromise().then(resp => {
      this.toastr.success("Risposte salvate correttamente.");
      this.imDirty.emit(false);
      this.lastImDirty = false;
      this.getRisposte();
    }).catch(error => {
      this.toastr.error("Errore nel salvataggio delle risposte.");
      console.error(error);
    });
  }


  /**
   * Richiede le risposte al backend. Se non ci sono, imposta i valori di default.
   */
  getRisposte() {
    const obj = { clinicalImpressionId: this.clinicalImpressionId, questionnaireId: this.idQuestionario };
    this.http.post(endpoints.getClinicalImpressionSurveyResponse, obj).toPromise()
    .then((resp: any) => {
      let tmpR;
      if (resp.item == undefined || resp.item.length == 0) {
        return this.initRisposte();
      }
      resp.item.forEach(rispostaFHIR => {
        if (rispostaFHIR.answer && rispostaFHIR.answer[0]) {
          tmpR = rispostaFHIR.answer[0].valueString;
        } else {
          tmpR = "";
        }
        this.getDomandaByLinkId(rispostaFHIR.linkId).risposta = tmpR;
      });
      this.imDirty.emit(false);
      this.lastImDirty = false;
    }).catch(error => {
      if (+error.status == 404) {
        this.toastr.info("Non ci sono questionari da compilare.");
        // this.router.navigate(['/main/pazienti/listapazienti']);
        return;
      } else {
        this.toastr.error("Errore nel caricamento delle risposte del questionario.")
        console.error("Errore nel recupero delle risposte del questionario ", this.idQuestionario, error);
      }
      this.initRisposte();
      this.imDirty.emit(false);
      this.lastImDirty = false;
    });
  }

  checkForm() {
    if (this.domande.find(x => x.risposta == undefined || (x.tipo == "integer" && isNaN(x.risposta))) != undefined) {
      return false;
    }
    return true;
  }

  /**
     * Cerca e restituisce la domanda con il linkId passato in input
     * @param linkId linkId da cercare
     * @returns domanda
     */
  private getDomandaByLinkId(linkId) {
    return this.domande.find(x => x.linkId == linkId);
  }

  /**
   * Imposta il valore di default a tutte le risposte.
   * In caso di scelta multipla, viene utilizzato il primo valore delle possibili risposte.
   */
  private initRisposte() {
    const boxes = Array.from(
      document.querySelectorAll('.ng5-slider-pointer-min') as NodeListOf<any>,
    );
    const boxes1 = Array.from(
      document.querySelectorAll('.ng5-slider-bubble') as NodeListOf<any>,
    );
    for (let i = 0; i < boxes.length; i++) {
      boxes[i].style.visibility = "hidden";
    }
    for (let i = 0; i < boxes1.length; i++) {
      boxes1[i].style.visibility = "hidden";
    }
    this.domande.forEach(domanda => {
      switch (domanda.tipo) {
        case 'string':
          domanda.risposta = "";
          break;
        case 'integer':
          domanda.risposta = undefined;
          break;
      }
    });
  }

  /**
   * Crea la configurazione delle tacche dello slider per la singola domanda.
   * @param risposteFHIR oggetto FHIR che rappresenta le possibili risposte alla singola domanda
   * @returns array che rappresenta le tacche sullo slider
   */
  private createStepsArrayFromAnswers(risposteFHIR) {
    let steps = new Array();
    if (risposteFHIR) {
      risposteFHIR.forEach(rispostaFHIR => {
        let tmp: any = {};
        tmp.value = +rispostaFHIR.valueCoding.code;
        if (rispostaFHIR.valueCoding.display) {
          tmp.legend = rispostaFHIR.valueCoding.display;
        }
        steps.push(tmp);
      });
    }
    return steps;
  }

  checkPermessoModifica() {
    return this.userService.checkOnlyPermission('Osservazioni', 'modify') && this.userService.checkOnlyPermission('Visite', 'modify');
  }

  OnChange() {
    this.imDirty.emit(true);
    this.lastImDirty = true;
  }

  canDeactivate(): boolean | Observable<boolean> | Promise<boolean> {
    return !this.lastImDirty;
  }

}
